var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"title"},[_vm._v("Talki")]),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":"/home"}},[_vm._v("Inicio")]),_c('a',{on:{"click":_vm.logOut}},[_vm._v("Cerrar Sesión")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }